import type { AppDefinition } from '../../../../types/apps';

const crclDefinition: AppDefinition = {
  appId: 'phys-crcl',
  name: 'CrCl Calculator',
  version: '1.0.0',
  description:
    'Creatinine Clearance (Cockcroft-Gault) and CKD-EPI eGFR — with IBW/AdjBW and renal dose-category guidance.',

  entityTypes: [],
  requiresEntity: false,
  requiresProps: false,
  preserveAppInstance: true,

  component: 'phys-crcl',

  icon: {
    type: 'phosphor' as const,
    phosphorIcon: 'Drop',
    phosphorWeight: 'duotone' as const,
    metadata: {
      source: 'app' as const,
      appId: 'phys-crcl',
      isAppIcon: true,
    },
  },

  agenticToolIds: ['physician_widget'],
  features: [],
  category: 'physician',
  isCore: false,
  isSystem: true,
};

export default crclDefinition;
